interface AddressFields {
  streetAddress: string;
  city: string;
  state: string;
  zip: string;
  ste?: string | null;
}

function isNullLike(value: string | null | undefined): boolean {
  return value == null || value === 'null' || String(value).trim() === '';
}

export function formatFullAddress<T extends AddressFields>(address: T | null): string {
  if (!address) {
    return 'Address not available';
  }

  const { streetAddress, ste, city, state, zip } = address;
  const parts: string[] = [];

  if (!isNullLike(streetAddress)) {
    parts.push(String(streetAddress).trim());
  }

  if (!isNullLike(ste)) {
    parts.push(`STE ${String(ste).trim()}`);
  }

  const cityStateZip = [city, state, zip].filter(v => !isNullLike(v)).map(v => String(v).trim());
  if (cityStateZip.length >= 3) {
    parts.push(`${cityStateZip[0]}, ${cityStateZip[1]} ${cityStateZip[2]}`);
  } else if (cityStateZip.length > 0) {
    parts.push(cityStateZip.join(', '));
  }

  return parts.length > 0 ? parts.join(', ') : 'Address not available';
}

/** A Google Maps search URL for a plain address string — no API key required. */
export function buildGoogleMapsUrl(address: string): string {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
}
